import React from 'react';
import { useInstallationFlow } from '../../hooks/useInstallationFlow';
import { ModalRenderer } from '../ModalRenderer/ModalRenderer';
export const App = () => {
  useInstallationFlow();
  return /*#__PURE__*/React.createElement(ModalRenderer, null);
};
//# sourceMappingURL=App.js.map